import { Module } from 'wrapper6'
import FloatingLabel from '../utils/_floating-label'

export default class FloatingLabels extends Module {
  ready (app) {
    const INPUT_LABELS = new FloatingLabel('input-wrap float-label', 'input')
    const TEXTAREA_LABELS = new FloatingLabel('textarea-wrap float-label', 'textarea')
  }
}
